import { Box, ColorOptions, convertHexToRGBA, useWindowDimensions } from '@jfs/ui-new'
import { useState } from 'react'
import { LinearGradientContainer } from '../../comps/LinearGradient'
import { Modal, ModalTypes } from '../../comps/ModalWeb'
import Navbar from '../../comps/Nav'
import NavMob from '../../comps/NavMobile'
import { colors } from '../../util/colors'
import usePadding from '../../util/usePadding'
import { isMobileWidth } from '../../util/util'
import EarnAsYouShare from './EarnAsYouShare'
import { Faqs } from './Faqs'
import { WelcomeBizzOwners } from './WelcomeBizzOwners'
import { styles } from './styles'

const PartnerProgram = () => {
  const [navVisible, setNavVisible] = useState(false)
  const setVisiblity = (): void => {
    document.body.style.overflow = 'scroll' // body scroll disabled
    setNavVisible(false)
  }
  const handleNav = (): void => {
    document.body.style.overflow = 'hidden' // body scroll disabled
    setNavVisible((prev) => !prev)
  }
  const nav = (
    <Box>
      <NavMob onPress={setVisiblity} />
    </Box>
  )
  const resPadding = usePadding()
  const width = useWindowDimensions()
  const isMobile = isMobileWidth(width)
  const borderRadius = width > 600 ? 100 : 24
  const themedStyle = styles(width, resPadding)
  return (
    <Box f={1}>
      <Modal view={nav} visible={navVisible} onPress={setVisiblity} type={ModalTypes.NAVBAR_RIGHT} />
      <Navbar onPress={handleNav} isLightBackground={true} />
      <Box
        {...themedStyle.container}
        h={'calc(100vh - 72px)'}
        bg={'WHITE'}
        borderTopWidth={1}
        borderTopColor={'#0000001F' as ColorOptions}>
        <EarnAsYouShare />
        <LinearGradientContainer
          colorArray={[convertHexToRGBA(colors.HOVER_SOLID, 40), convertHexToRGBA('#F1E5FF', 40)]}
          useAngle={true}
          angle={125}
          customStyle={{
            width: '100%',
            borderTopLeftRadius: borderRadius,
            borderTopRightRadius: borderRadius,
            paddingTop: isMobile ? 72 : 110,
            paddingBottom: isMobile ? 80 : 210,
            paddingHorizontal: resPadding,
          }}>
          <WelcomeBizzOwners />
        </LinearGradientContainer>

        <Faqs />
      </Box>
    </Box>
  )
}

export default PartnerProgram
